/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsStaffOrdersCtrl
 */
angular.module('mercury.modules.reports.staff')
.controller('ReportsStaffSalesCtrl', ["$filter", "$scope", "reporttime", "ReportPosStaff", "title", function($filter, $scope, reporttime, ReportPosStaff, title) {
  title.set('Staff Sales');

  $scope.staffSalesCols = [
    {label: 'Staff Name', type: 'string', key: 'label'},
    {label: 'Orders', type: 'number', key: 'invoices', filter: 'currency'}
  ];

  $scope.loading = ReportPosStaff.getSales(reporttime.start(), reporttime.end());
  $scope.loading.then(function(staffOrders) {
    $scope.staffSales = staffOrders;

    $scope.totalSales = $filter('sumof')(staffOrders, 'invoices');
    $scope.totalQuantity = $filter('sumof')(staffOrders, 'quantity');
  });
}]);
